import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Select from "react-select";
import * as api from "../../constant/API";
import Utils from "../../constant/Utils";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

interface AcademicProps {
    onDataChange: (data: any) => void
    onBack: () => void
    isEdit: boolean;
    insDet: (data: any[]) => void
    sprtDet: (data: any[]) => void
    progDet: (data: any[]) => void;
    billDet: (data: any[]) => void
    studDet: (data: any) => void
    formcheck: () => void;
    submit: () => void;
}

const Academic: React.FC<AcademicProps> = ({ onDataChange, onBack, isEdit, insDet, sprtDet, progDet, billDet, studDet, formcheck, submit }) => {
    let initialFormState;

    if (studDet != null) {
        initialFormState = {
            height: studDet[0].coreUserHeight, weight: studDet[0].coreUserWeight, bldgrp: studDet[0].coreUserBloodGroup, emrgycntctname: studDet[0].coreUserEmergencyContact,
            emrgycntctnum: studDet[0].coreUserEmergencyContactNo, institute: studDet[0].coreUserInstituteId, class: studDet[0].coreUserClassId, section: studDet[0].coreUserSectionId,
            admsndate: studDet[0].coreUserAdmissionDate, academicyr: studDet[0].coreUserAcademicYear, sport: studDet[0].coreUserSportId, prog: studDet[0].coreUserProgramId,
            achvmnt: studDet[0].coreUserAchievement, usrname: studDet[0].Username, billingtyp: '', slab: studDet[0].coreUserSlabId, status: studDet[0].coreUserStatus
        }
    }
    else {
        initialFormState = {
            height: '', weight: '', bldgrp: '', emrgycntctname: '', emrgycntctnum: '', institute: '', class: '', section: '', admsndate: '',
            academicyr: '', sport: '', prog: '', achvmnt: '', usrname: '', billingtyp: '', slab: ''
        }
    }
    const [formData, setFormData] = useState(initialFormState);
    const [classList, setClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [slabList, setSlabList] = useState([]);

    const bloodGroupOptions = [
        { value: "A+", label: "A+" },
        { value: "A-", label: "A-" },
        { value: "B+", label: "B+" },
        { value: "B-", label: "B-" },
        { value: "AB+", label: "AB+" },
        { value: "AB-", label: "AB-" },
        { value: "O+", label: "O+" },
        { value: "O-", label: "O-" }
    ];

    const statusOptions = [
        { value: "0", label: "Inactive" },
        { value: "1", label: "Active" },
    ];

    useEffect(() => {
        if (studDet != null) {
            getClass(studDet[0].coreUserInstituteId)
            getSections(studDet[0].coreUserClassId)

            setFormData(initialFormState);
            onDataChange(initialFormState); // Send data to AddStudent
        }
    }, [])

    function getClass(ins) {
        const clasFetch = api.Class + '/' + ins;
        fetch(clasFetch, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setClassList(result.data)
                } else {
                    Swal.fire(result.message)
                }
            })
    }

    function getSections(cls) {
        const sectionsFetch = api.SectionsByClassId + '/' + cls+'/'+formData.institute;
        fetch(sectionsFetch, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setSectionList(result.data)
                }
                else {
                    Swal.fire(result.message)
                }
            })
    }

    function getSlab(bill) {
        const slabFetch = api.SlabList + '/' + bill;
        fetch(slabFetch, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setSlabList(result.data)
                }
                else {
                    Swal.fire(result.message)
                }
            })
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const updatedData = { ...formData, [name]: value };
        setFormData(updatedData);
        onDataChange(updatedData); // Send data to AddStudent
    };

    return (
        <form ref={formcheck}>
            <div className="card card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-4 mb-10">
                                    <label className="form-label">Height(cm)</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="height"
                                        value={formData.height}
                                        onChange={handleChange}
                                        placeholder="Student Height in Centimeter" />
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <label className="form-label">Weight(Kg)</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="weight"
                                        value={formData.weight}
                                        onChange={handleChange}
                                        placeholder="Student Weight in Kilogram" />
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <label className="form-label">Blood group</label>
                                    <Select
                                        value={bloodGroupOptions.find(bg => bg.value === formData.bldgrp) ? {
                                            value: formData.bldgrp,
                                            label: bloodGroupOptions.find(bg => bg.value === formData.bldgrp)?.label
                                        } : null}
                                        onChange={(e) => {
                                            handleChange({ target: { name: "bldgrp", value: e ? e.value : "" } });
                                        }}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                height: "40px",  // ✅ Sets the height of the input field
                                                minHeight: "40px", // Ensures it doesn’t shrink
                                                border: "1px solid hsl(0, 0%, 80%)",
                                                borderRadius: "5px",
                                                boxShadow: "none",
                                            }),
                                            valueContainer: (base) => ({
                                                ...base,
                                                height: "40px",  // ✅ Ensures selected value container follows the height
                                                display: "flex",
                                                alignItems: "center", // Keeps text vertically centered
                                                padding: "0px 10px 0px 10px"
                                            }),
                                            input: (base) => ({
                                                ...base,
                                                margin: "0px",
                                                padding: "0px"
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                lineHeight: "40px" // ✅ Aligns placeholder text properly
                                            }),
                                            dropdownIndicator: (base) => ({
                                                ...base,
                                                padding: "5px"
                                            }),
                                        }}
                                        placeholder="Select Blood Group"
                                        options={bloodGroupOptions.map(bg => ({
                                            value: bg.value,
                                            label: bg.label
                                        }))}
                                    >
                                    </Select>
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <label className="form-label">Emergency Contact Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="emrgycntctname"
                                        value={formData.emrgycntctname}
                                        onChange={handleChange}
                                        placeholder="Emergency Contact Name" />
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <label className="form-label">Emergency Contact Number</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="emrgycntctnum"
                                        // value={formData.emrgycntctnum}
                                        value={formData.emrgycntctnum === "NA" ? "" : formData.emrgycntctnum}
                                        onChange={handleChange}
                                        placeholder="Emergency Contact Number" />
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Institute</label>
                                        <Select
                                            value={insDet.find(ins => ins.institutionId === formData.institute) ? {
                                                value: formData.institute,
                                                label: insDet.find(ins => ins.institutionId === formData.institute).institutionName
                                            } : null}
                                            required
                                            onChange={(e) => {
                                                handleChange({ target: { name: "institute", value: e ? e.value : "" } });
                                                getClass(e?.value)
                                            }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Sets the height of the input field
                                                    minHeight: "40px", // Ensures it doesn’t shrink
                                                    border: "1px solid hsl(0, 0%, 80%)",
                                                    borderRadius: "5px",
                                                    boxShadow: "none",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Ensures selected value container follows the height
                                                    display: "flex",
                                                    alignItems: "center", // Keeps text vertically centered
                                                    padding: "0px 10px 0px 10px"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    margin: "0px",
                                                    padding: "0px"
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    lineHeight: "40px" // ✅ Aligns placeholder text properly
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    padding: "5px"
                                                }),
                                            }}
                                            placeholder="Select Institute"
                                            options={insDet.map(ins => ({
                                                value: ins.institutionId,
                                                label: ins.institutionName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Class</label>
                                        <Select
                                            value={classList.find(cls => cls.classId === formData.class) ? {
                                                value: formData.class,
                                                label: classList.find(cls => cls.classId === formData.class).className
                                            } : null}
                                            required
                                            onChange={(e) => {
                                                handleChange({ target: { name: "class", value: e ? e.value : "" } });
                                                getSections(e.value)
                                            }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Sets the height of the input field
                                                    minHeight: "40px", // Ensures it doesn’t shrink
                                                    border: "1px solid hsl(0, 0%, 80%)",
                                                    borderRadius: "5px",
                                                    boxShadow: "none",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Ensures selected value container follows the height
                                                    display: "flex",
                                                    alignItems: "center", // Keeps text vertically centered
                                                    padding: "0px 10px 0px 10px"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    margin: "0px",
                                                    padding: "0px"
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    lineHeight: "40px" // ✅ Aligns placeholder text properly
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    padding: "5px"
                                                }),
                                            }}
                                            placeholder="Select Class"
                                            options={classList.map(cls => ({
                                                value: cls.classId,
                                                label: cls.className
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Section</label>
                                        <Select
                                            value={sectionList.find(sec => sec.sectionId === formData.section) ? {
                                                value: formData.section,
                                                label: sectionList.find(sec => sec.sectionId === formData.section).sectionName
                                            } : null}
                                            onChange={(e) => {
                                                handleChange({ target: { name: "section", value: e ? e.value : "" } });
                                            }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Sets the height of the input field
                                                    minHeight: "40px", // Ensures it doesn’t shrink
                                                    border: "1px solid hsl(0, 0%, 80%)",
                                                    borderRadius: "5px",
                                                    boxShadow: "none",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Ensures selected value container follows the height
                                                    display: "flex",
                                                    alignItems: "center", // Keeps text vertically centered
                                                    padding: "0px 10px 0px 10px"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    margin: "0px",
                                                    padding: "0px"
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    lineHeight: "40px" // ✅ Aligns placeholder text properly
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    padding: "5px"
                                                }),
                                            }}
                                            placeholder="Select Section"
                                            options={sectionList.map(sec => ({
                                                value: sec.sectionId,
                                                label: sec.sectionName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <label className="form-label">Admission Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="admsndate"
                                        value={formData.admsndate}
                                        onChange={handleChange}
                                        placeholder="Admission Date" />
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <label className="form-label">Academic Year</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="academicyr"
                                        value={formData.academicyr}
                                        onChange={handleChange}
                                        placeholder="Academic Year" />
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sport</label>
                                        <Select
                                            value={sprtDet.find(sprt => sprt.sportId === formData.sport) ? {
                                                value: formData.sport,
                                                label: sprtDet.find(sprt => sprt.sportId === formData.sport).sportName
                                            } : null}
                                            onChange={(e) => {
                                                handleChange({ target: { name: "sport", value: e ? e.value : "" } });
                                            }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Sets the height of the input field
                                                    minHeight: "40px", // Ensures it doesn’t shrink
                                                    border: "1px solid hsl(0, 0%, 80%)",
                                                    borderRadius: "5px",
                                                    boxShadow: "none",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Ensures selected value container follows the height
                                                    display: "flex",
                                                    alignItems: "center", // Keeps text vertically centered
                                                    padding: "0px 10px 0px 10px"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    margin: "0px",
                                                    padding: "0px"
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    lineHeight: "40px" // ✅ Aligns placeholder text properly
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    padding: "5px"
                                                }),
                                            }}
                                            placeholder="Select Sport"
                                            options={sprtDet.map(sprt => ({
                                                value: sprt.sportId,
                                                label: sprt.sportName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Program</label>
                                        <Select
                                            value={progDet.find(prg => prg.programId === formData.prog) ? {
                                                value: formData.prog,
                                                label: progDet.find(prg => prg.programId === formData.prog).programName
                                            } : null}
                                            onChange={(e) => {
                                                handleChange({ target: { name: "prog", value: e ? e.value : "" } });
                                            }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Sets the height of the input field
                                                    minHeight: "40px", // Ensures it doesn’t shrink
                                                    border: "1px solid hsl(0, 0%, 80%)",
                                                    borderRadius: "5px",
                                                    boxShadow: "none",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Ensures selected value container follows the height
                                                    display: "flex",
                                                    alignItems: "center", // Keeps text vertically centered
                                                    padding: "0px 10px 0px 10px"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    margin: "0px",
                                                    padding: "0px"
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    lineHeight: "40px" // ✅ Aligns placeholder text properly
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    padding: "5px"
                                                }),
                                            }}
                                            placeholder="Select a Program"
                                            options={progDet.map(prog => ({
                                                value: prog.programId,
                                                label: prog.programName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <label className="form-label">Achievement</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="achvmnt"
                                        value={formData.achvmnt}
                                        onChange={handleChange}
                                        placeholder="Achievement" />
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <label className="form-label">Username</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="usrname"
                                        value={formData.usrname}
                                        onChange={handleChange}
                                        placeholder="Username" />
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Billing Type</label>
                                        <Select
                                            value={billDet.find(bil => bil.billingTypeId === formData.billingtyp) ? {
                                                value: formData.billingtyp,
                                                label: billDet.find(bil => bil.billingTypeId === formData.billingtyp).billingTypeName
                                            } : null}
                                            onChange={(e) => {
                                                handleChange({ target: { name: "billingtyp", value: e ? e.value : "" } });
                                                getSlab(e.value)
                                            }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Sets the height of the input field
                                                    minHeight: "40px", // Ensures it doesn’t shrink
                                                    border: "1px solid hsl(0, 0%, 80%)",
                                                    borderRadius: "5px",
                                                    boxShadow: "none",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Ensures selected value container follows the height
                                                    display: "flex",
                                                    alignItems: "center", // Keeps text vertically centered
                                                    padding: "0px 10px 0px 10px"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    margin: "0px",
                                                    padding: "0px"
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    lineHeight: "40px" // ✅ Aligns placeholder text properly
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    padding: "5px"
                                                }),
                                            }}
                                            placeholder="Select Billing Type"
                                            options={billDet.map(bil => ({
                                                value: bil.billingTypeId,
                                                label: bil.billingTypeName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Slab</label>
                                        <Select
                                            value={slabList.find(slb => slb.billingSlabId === formData.slab) ? {
                                                value: formData.slab,
                                                label: slabList.find(slb => slb.billingSlabId === formData.slab).billingSlabName
                                            } : null}
                                            onChange={(e) => {
                                                handleChange({ target: { name: "slab", value: e ? e.value : "" } });
                                            }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Sets the height of the input field
                                                    minHeight: "40px", // Ensures it doesn’t shrink
                                                    border: "1px solid hsl(0, 0%, 80%)",
                                                    borderRadius: "5px",
                                                    boxShadow: "none",
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    height: "40px",  // ✅ Ensures selected value container follows the height
                                                    display: "flex",
                                                    alignItems: "center", // Keeps text vertically centered
                                                    padding: "0px 10px 0px 10px"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    margin: "0px",
                                                    padding: "0px"
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    lineHeight: "40px" // ✅ Aligns placeholder text properly
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    padding: "5px"
                                                }),
                                            }}
                                            placeholder="Select a Slab"
                                            options={slabList.map(slb => ({
                                                value: slb.billingSlabId,
                                                label: slb.billingSlabName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                {(studDet != null) ?
                                    <div className="col-lg-4 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Status</label>
                                            <Select
                                                value={statusOptions.find(stat => stat.value === formData.status) ? {
                                                    value: formData.status,
                                                    label: statusOptions.find(stat => stat.value === formData.status).label
                                                } : null}
                                                onChange={(e) => {
                                                    handleChange({ target: { name: "status", value: e ? e.value : "" } });
                                                }}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        height: "40px",  // ✅ Sets the height of the input field
                                                        minHeight: "40px", // Ensures it doesn’t shrink
                                                        border: "1px solid hsl(0, 0%, 80%)",
                                                        borderRadius: "5px",
                                                        boxShadow: "none",
                                                    }),
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        height: "40px",  // ✅ Ensures selected value container follows the height
                                                        display: "flex",
                                                        alignItems: "center", // Keeps text vertically centered
                                                        padding: "0px 10px 0px 10px"
                                                    }),
                                                    input: (base) => ({
                                                        ...base,
                                                        margin: "0px",
                                                        padding: "0px"
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        lineHeight: "40px" // ✅ Aligns placeholder text properly
                                                    }),
                                                    dropdownIndicator: (base) => ({
                                                        ...base,
                                                        padding: "5px"
                                                    }),
                                                }}
                                                options={statusOptions.map(stat => ({
                                                    value: stat.value,
                                                    label: stat.label
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    : null
                                }
                                <div className="d-md-flex justify-content-between align-items-center">
                                    <div className="qty-item text-center">
                                        <Link className="btn btn-primary me-3 btn-icon" to="#" onClick={onBack}><i className="feather-arrow-left-circle me-1" /> Back</Link>
                                    </div>
                                    <div className="qty-item text-center">
                                        <Button
                                            className="btn-primary"
                                            variant="success"
                                            // onClick={saveStudent}
                                            onClick={submit}
                                        >
                                            <b>{isEdit ? "Update" : "Save"}</b>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default Academic;